import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { get } from "lodash";
import { Link } from "react-router-dom";

export default function MatchingStrains({ id }) {
  const dispatch = useDispatch();

  const loading = useSelector((state) =>
    get(state, `prismic.strains-${id}.loading`, true)
  );
  const data = useSelector((state) =>
    get(state, `prismic.strains-${id}.data`, false)
  );

  const strainImage = get(data, "data.image.url");

  const uid = get(data, "uid");

  useEffect(() => {
    dispatch({
      type: "PRISMIC_LOAD_SINGLE_BY_UID",
      key: "strains",
      reduxKey: `strains-${id}`,
      raw: true,
      id,
    });
  }, [dispatch, id]);

  return (
    !loading &&
    data && (
      <Link target="_blank" to={`/strains/${uid}`} className="strain-image">
        <img src={strainImage} alt={id + " strain"} />
      </Link>
    )
  );
}
